import React from "react";

import whatsapp from "../assets/images/whatsapp.png";

const WhatsAppButton = () => {

  return (

    <a

      href="https://wa.me/919092997705?text=Hello%20Vder%20Tours%2C%20I%20would%20like%20to%20know%20more%20about%20your%20tour%20packages."

      target="_blank"

      rel="noopener noreferrer"

      style={{

        position: "fixed",

        bottom: "20px",

        right: "20px",

        width: "70px",

        height: "70px",

        backgroundColor: "#25D366",

        borderRadius: "50%",

        zIndex: 999999,

        display: "flex",

        justifyContent: "center",

        alignItems: "center",

        textDecoration: "none",

        cursor: "pointer"

      }}

    >

      <img

        src={whatsapp}

        alt="WhatsApp"

        style={{

          width: "42px",

          height: "42px"

        }}

      />

    </a>

  );

};

export default WhatsAppButton;